<template>
  <form @submit.prevent="submit">
    <div class="d-flex justify-content-center pb-1">
      <Icon icon="safe-harbor" color="epsilon" :size="50" />
    </div>
    <div class="d-flex justify-content-center">
      <h1>{{ $t("global.safe-harbor") }}</h1>
    </div>
    <div class="d-flex justify-content-center pb-4">{{ getCost() }}</div>
    <div>
      <h2 class="pb-2">{{ $t("global.features") }}</h2>
      <div class="pb-3">
        <h4>{{ $t("global.malware-scans") }}</h4>
        <div>{{ $t("global.malware-scans-description") }}</div>
      </div>
      <div class="pb-3">
        <h4>{{ $t("global.threat-protection") }}</h4>
        <div>{{ $t("global.threat-protection-description") }}</div>
      </div>
      <div class="pb-3">
        <h4>{{ $t("global.staging-environment") }}</h4>
        <div>{{ $t("global.staging-environment-description") }}</div>
      </div>
      <div>
        <h4>{{ $t("global.magento-patches") }}</h4>
        <div>{{ $t("global.magento-patches-description") }}</div>
      </div>
    </div>
    <div class="form-buttons">
      <Btn
        class="mr-2"
        variant="light"
        type="button"
        :disabled="isSubmitting"
        @click="cancel"
        data-test="cancel-purchase-safe-harbor-button"
      >
        {{ $t("global.cancel") }}
      </Btn>
      <Btn
        variant="primary"
        type="submit"
        :disabled="!isSubmittable()"
        :loading="isSubmitting"
        data-test="purchase-safe-harbor-button"
      >
        {{ $t("global.purchase") }}
      </Btn>
    </div>
  </form>
</template>

<script>
import Btn from "@/components/display/Btn";
import Icon from "@/components/display/icon/Icon";
import { moneyFormat } from "leatherman-js/utils/formatters/money";
import { ref } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "SafeHarborPurchaseForm",
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  components: {
    Btn,
    Icon,
  },
  setup(props, { emit, root }) {
    const isSubmitting = ref(false);

    const cancel = () => emit("close");

    const getCost = () =>
      `${root.$t("global.monthly-cost")}: ${moneyFormat(
        props.service.package.safeHarbor.termFee[props.service.term] * props.service.term
      )}`;

    const isShared = () => props.service.type === "shared";

    const isSubmittable = () => !isSubmitting.value;
    const submit = () => {
      isSubmitting.value = true;
      store
        .dispatch("safeHarbor/purchase", {
          serviceId: props.service.id,
          data: {
            addonId: props.service.package.safeHarbor.id,
          },
        })
        .then(() => {
          if (isShared()) {
            store.dispatch("safeHarbor/addUpdate", props.service.id);
          }
          store.dispatch("toasts/addToast", {
            variant: "info",
            message: root.$t("toasts.safe-harbor-enabling-message"),
          });
          emit("close");
        })
        .catch(() => {
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: root.$t("toasts.safe-harbor-enable-error-message"),
          });
        })
        .finally(() => {
          isSubmitting.value = false;
        });
    };

    return {
      cancel,
      getCost,
      isSubmittable,
      isSubmitting,
      submit,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
.form-buttons {
  text-align: right;
  padding-top: 2rem;
}
</style>
